import EnvironmentUtils from '@spothero/utils/environment';

const CloudinaryUtils = {
    transformations(width, height) {
        return {
            width,
            height,
            crop: 'fill',
            dpr: (EnvironmentUtils.isHighDensityDisplay()) ? 2 : 1,
            flags: 'progressive',
            quality: 50,
            fetch_format: 'auto' // eslint-disable-line camelcase
        };
    }
};

export default CloudinaryUtils;
